<template>
  <v-container fluid fill-height>
      <v-layout align-center justify-center>
      <v-flex xs12 sm12 md6 lg6>
        <v-card height="500px">
            <v-select-radio label="wwwwwww" v-model="checkboxValue" :items="items"></v-select-radio>
            <v-select-check v-model="checkboxValue" :items="items"></v-select-check>
            <v-textarea></v-textarea>
            <v-html-field ref="editor1" v-model="htmlValue" macro label="html редактор1" @check="check"></v-html-field>
            <v-flex>
            <v-macro-field  v-model="htmlValue2" macro label="html редактор2"></v-macro-field>
            </v-flex>
            <div>{{htmlValue}}</div>
            <br/>
            <div>{{replaceMacroTags(htmlValue)}}</div>
            <v-card-actions>
              <v-btn block @click="open" color="primary">Макро</v-btn>
            </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import vSelectRadio from './common/SelectRadio.vue'
  import vSelectCheck from './common/SelectCheck.vue'
  import vHtmlField from './common/HtmlField.vue'
  import vMacroField from './common/MacroField.vue'
  // import forms from './common/forms.js'
  import formats from '../api/formats.js'

  export default {
    components: {vSelectRadio, vSelectCheck, vHtmlField, vMacroField},
    data: () => {
      return {
        items: [
          {value: 'ATTACH', text: 'Прикрепить файлы'},
          {value: 'DEPO_LINK', text: 'Без файлов'}
        ],
        checkboxValue: 'Не выбрано',
        htmlValue: 'введите текст1',
        htmlValue2: 'введите текст2'
      }
    },
    beforeRouteLeave (to, from, next) {
      console.log('beforeRouteLeave: HOME')
      next()
    },
    methods: {
      createComp (template) {
        return formats.createComp(`<span>${template}</span>`)
      },
      replaceMacroTags (value) {
        let tags = []
        let div = document.createElement('div')
        div.innerHTML = value
        div.querySelectorAll('a').forEach(node => {
          if (node.href && /xslt:/ig.test(node.href)) {
            tags.push({find: node.outerHTML, replace: node.href.replaceAll(/xslt:/ig, '')})
          }
        })
        let text = value
        tags.forEach(tag => {
          text = text.replace(tag.find, tag.replace)

        })
        console.log('replaceMacroTags', tags, text)
        return text
      },
      open () {
        let action = 'macro'
        this.$refs.editor1.editor.$store.dispatch('showPopup', { name: action, params: null })
        this.$refs.editor1.editor.$store.dispatch('updatePopupDisplay', {name: action, display: true})
      },
      check (content) {
        console.log('check', content, this.$refs.editor1.editor.$store)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Test.vue?53a2619a